// columns.js
import { formatMoney } from "./format";

// Performance Overview columns - for admin view showing all clinics
export const performanceOverviewColumns = () => [
  {
    key: "clinic",
    header: "CLINIC",
    width: 150,
  },
  {
    key: "collection",
    header: "COLLECTION",
    width: 130,
    render: (r) => formatMoney(r.collection),
  },
  {
    key: "total_costs",
    header: "TOTAL COSTS",
    width: 130,
    render: (r) => formatMoney(r.total_costs),
  },
  {
    key: "production",
    header: "PRODUCTION",
    width: 130,
    render: (r) => formatMoney(r.production),
  },
];

// Practitioner breakdown columns for overview - per clinic practitioners
export const practitionerOverviewColumns = () => [
  {
    key: "practitioner_name",
    header: "PRACTITIONER",
    width: 150,
    render: (r) => r.practitioner_name || "-",
  },
  {
    key: "practitioner_type",
    header: "DDS/HYG",
    width: 80,
    render: (r) => (r.practitioner_type ? r.practitioner_type.toUpperCase() : "-"),
  },
  {
    key: "category",
    header: "CATEGORY",
    width: 120,
    render: (r) => r.category || "-",
  },
];

// Cost and collection breakdown columns for overview
export const costCollectionOverviewColumns = () => [
  {
    key: "cash",
    header: "CASH",
    width: 100,
    render: (r) => formatMoney(r.cash),
  },
  {
    key: "debit",
    header: "DEBIT",
    width: 100,
    render: (r) => formatMoney(r.debit),
  },
  {
    key: "mastercard",
    header: "MASTERCARD",
    width: 110,
    render: (r) => formatMoney(r.mastercard),
  },
  {
    key: "visa",
    header: "VISA",
    width: 90,
    render: (r) => formatMoney(r.visa),
  },
  {
    key: "amex",
    header: "AMEX",
    width: 90,
    render: (r) => formatMoney(r.amex),
  },
  {
    key: "checks",
    header: "CHECKS",
    width: 100,
    render: (r) => formatMoney(r.checks),
  },
  {
    key: "insurance_check",
    header: "INS. CHECK",
    width: 100,
    render: (r) => formatMoney(r.insurance_check),
  },
  {
    key: "personal_eft",
    header: "PERSONAL EFT",
    width: 110,
    render: (r) => formatMoney(r.personal_eft),
  },
  {
    key: "insurance_eft",
    header: "INS. EFT",
    width: 100,
    render: (r) => formatMoney(r.insurance_eft),
  },
  {
    key: "other",
    header: "OTHER",
    width: 100,
    render: (r) => formatMoney(r.other),
  },
  {
    key: "lab_costs",
    header: "LAB COSTS",
    width: 110,
    render: (r) => formatMoney(r.lab_costs),
  },
  {
    key: "invisalign_costs",
    header: "INVISALIGN",
    width: 110,
    render: (r) => formatMoney(r.invisalign_costs),
  },
  {
    key: "material_costs",
    header: "MATERIAL",
    width: 110,
    render: (r) => formatMoney(r.material_costs),
  },
  {
    key: "hours_worked",
    header: "HOURS",
    width: 90,
    render: (r) => (r.hours_worked ? Number(r.hours_worked).toFixed(2) : "0.00"),
  },
];

export const performanceColumns = () => [
  {
    key: "date",
    header: "DATE",
    render: (r) => <span className={r.isMTDRow ? "font-bold" : ""}>{r.date}</span>,
  },
  {
    key: "collection",
    header: "COLLECTION",
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.collection)}</span>
    ),
  },
  {
    key: "total_costs",
    header: "TOTAL COSTS",
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.total_costs)}</span>
    ),
  },
  {
    key: "production",
    header: "PRODUCTION",
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.production)}</span>
    ),
  },
];

// Additional practitioner columns - added to performance columns when showPractitioner is true
export const practitionerBreakdownColumns = () => [
  {
    key: "practitioner_name",
    header: "PRACTITIONER",
    width: 150,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>
        {r.isMTDRow ? "" : r.practitioner_name || "-"}
      </span>
    ),
  },
  {
    key: "practitioner_type",
    header: "TYPE",
    width: 80,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>
        {r.isMTDRow ? "" : r.practitioner_type ? r.practitioner_type.toUpperCase() : "-"}
      </span>
    ),
  },
  {
    key: "practitioner_collection",
    header: "PRACTITIONER COLLECTION",
    width: 160,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>
        {formatMoney(r.practitioner_collection)}
      </span>
    ),
  },
  {
    key: "total_cost",
    header: "TOTAL COST",
    width: 120,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.total_cost)}</span>
    ),
  },
  {
    key: "practitioner_production",
    header: "PRACTITIONER PRODUCTION",
    width: 170,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>
        {formatMoney(r.practitioner_production)}
      </span>
    ),
  },
  {
    key: "category",
    header: "CATEGORY",
    width: 120,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{r.isMTDRow ? "" : r.category || "-"}</span>
    ),
  },
];

// Clinic `hidden_columns` still use legacy keys from the old single "credit" / "eft" columns.
// Map those to the new granular columns so existing clinic configs keep working without re-saving.
const costCollectionBreakdownHidden = (key, hiddenColumns) => {
  if (hiddenColumns.includes(key)) return true;
  if (hiddenColumns.includes("credit") && ["debit", "mastercard", "visa", "amex"].includes(key))
    return true;
  if (hiddenColumns.includes("eft") && ["personal_eft", "insurance_eft"].includes(key)) return true;
  return false;
};

// DRY: money cells in this table should match the MTD footer row weight (bold when isMTDRow).
const boldMoney = (r, v) => <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(v)}</span>;

// Cost and collection breakdown columns - standalone view when showCostCollection is true
export const costAndCollectionBreakdownColumns = (hiddenColumns = []) =>
  [
    {
      key: "date",
      header: "DATE",
      width: 100,
      render: (r) => <span className={r.isMTDRow ? "font-bold" : ""}>{r.date}</span>,
    },
    {
      key: "cash",
      header: "CASH",
      width: 95,
      render: (r) => boldMoney(r, r.cash),
    },
    {
      key: "debit",
      header: "DEBIT",
      width: 95,
      render: (r) => boldMoney(r, r.debit),
    },
    {
      key: "mastercard",
      header: "MASTERCARD",
      width: 105,
      render: (r) => boldMoney(r, r.mastercard),
    },
    {
      key: "visa",
      header: "VISA",
      width: 90,
      render: (r) => boldMoney(r, r.visa),
    },
    {
      key: "amex",
      header: "AMEX",
      width: 90,
      render: (r) => boldMoney(r, r.amex),
    },
    {
      key: "checks",
      header: "CHECKS",
      width: 95,
      render: (r) => boldMoney(r, r.checks),
    },
    {
      key: "insurance_check",
      header: "INS. CHECK",
      width: 100,
      render: (r) => boldMoney(r, r.insurance_check),
    },
    {
      key: "personal_eft",
      header: "PERSONAL EFT",
      width: 105,
      render: (r) => boldMoney(r, r.personal_eft),
    },
    {
      key: "insurance_eft",
      header: "INS. EFT",
      width: 95,
      render: (r) => boldMoney(r, r.insurance_eft),
    },
    {
      key: "other",
      header: "OTHER",
      width: 95,
      render: (r) => boldMoney(r, r.other),
    },
    {
      key: "collection",
      header: "COLLECTION TOTAL",
      width: 130,
      render: (r) => boldMoney(r, r.collection),
    },
    {
      key: "lab_costs",
      header: "LAB COSTS",
      width: 110,
      render: (r) => (
        <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.lab_costs)}</span>
      ),
    },
    {
      key: "invisalign_costs",
      header: "INVISALIGN",
      width: 110,
      render: (r) => (
        <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.invisalign_costs)}</span>
      ),
    },
    {
      key: "material_costs",
      header: "MATERIAL",
      width: 110,
      render: (r) => (
        <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.material_costs)}</span>
      ),
    },
    {
      key: "hours_worked",
      header: "HOURS",
      width: 90,
      render: (r) => (
        <span className={r.isMTDRow ? "font-bold" : ""}>
          {r.hours_worked ? Number(r.hours_worked).toFixed(2) : "0.00"}
        </span>
      ),
    },
    {
      key: "production",
      header: "PRODUCTION",
      width: 120,
      render: (r) => (
        <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.production)}</span>
      ),
    },
    {
      key: "total_costs",
      header: "TOTAL COSTS",
      width: 120,
      render: (r) => (
        <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.total_costs)}</span>
      ),
    },
  ].filter((col) => !costCollectionBreakdownHidden(col.key, hiddenColumns));

// Legacy function - kept for backwards compatibility but not used in PerformanceGlance
export const performanceAllColumns = () => [
  // Date
  {
    key: "date",
    header: "DATE",
    width: 100,
    render: (r) => <span className={r.isMTDRow ? "font-bold" : ""}>{r.date}</span>,
  },
  // Practitioner columns
  {
    key: "practitioner_name",
    header: "PRACTITIONER",
    width: 130,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>
        {r.isMTDRow ? "" : r.practitioner_name || "-"}
      </span>
    ),
  },
  {
    key: "practitioner_type",
    header: "TYPE",
    width: 70,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>
        {r.isMTDRow ? "" : r.practitioner_type ? r.practitioner_type.toUpperCase() : "-"}
      </span>
    ),
  },
  {
    key: "category",
    header: "CATEGORY",
    width: 100,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{r.isMTDRow ? "" : r.category || "-"}</span>
    ),
  },
  // Cost & Collection breakdown columns
  {
    key: "collection_credit",
    header: "CREDIT",
    width: 100,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.collection_credit)}</span>
    ),
  },
  {
    key: "collection_cash",
    header: "CASH",
    width: 100,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.collection_cash)}</span>
    ),
  },
  {
    key: "collection_eft",
    header: "E-TRANSFER",
    width: 100,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.collection_eft)}</span>
    ),
  },
  {
    key: "collection_other",
    header: "OTHER",
    width: 100,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.collection_other)}</span>
    ),
  },
  {
    key: "practitioner_collection",
    header: "PRACTITIONER COLLECTION",
    width: 110,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>
        {formatMoney(r.practitioner_collection)}
      </span>
    ),
  },
  {
    key: "collection_total",
    header: "COLL. TOTAL",
    width: 110,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.collection_total)}</span>
    ),
  },
  {
    key: "lab_costs",
    header: "LAB COSTS",
    width: 100,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.lab_costs)}</span>
    ),
  },
  {
    key: "invisalign_costs",
    header: "INVISALIGN",
    width: 100,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.invisalign_costs)}</span>
    ),
  },
  {
    key: "material_costs",
    header: "MATERIAL",
    width: 100,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.material_costs)}</span>
    ),
  },
  {
    key: "hours_worked",
    header: "HOURS",
    width: 80,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>
        {r.hours_worked ? Number(r.hours_worked).toFixed(2) : "0.00"}
      </span>
    ),
  },
  {
    key: "practitioner_production",
    header: "PRODUCTION",
    width: 110,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>
        {formatMoney(r.practitioner_production)}
      </span>
    ),
  },
  {
    key: "total_costs",
    header: "TOTAL COSTS",
    width: 110,
    render: (r) => (
      <span className={r.isMTDRow ? "font-bold" : ""}>{formatMoney(r.total_costs)}</span>
    ),
  },
];
